module.exports = __webpack_public_path__ + "img/image02-left.f0bbe828.png";